export default __webpack_public_path__ + "static/media/HISTORY_COMMUNITY.f957b7f4.svg";